/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}.footer-container[_ngcontent-%COMP%]{position:absolute;bottom:0;right:40px;height:42px}.footer-container[_ngcontent-%COMP%]   .footer-text[_ngcontent-%COMP%]{font-size:.82rem;color:#717d8d}.footer-container[_ngcontent-%COMP%]   .logo-container[_ngcontent-%COMP%]{padding:0 3px}.footer-container[_ngcontent-%COMP%]   .logo-container[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{max-width:35px;max-height:25px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer-footer/pdf-viewer-footer.component.scss.shim.ngstyle.js.pre-build-optimizer.js